<template>
  <div class="forgot-pass"
		:style="removeBgbyWindowSize"	  
  >
    <div class="bar"
			:style="{
				'background': colors.primary
			}"		
		></div>
    <BackLink></BackLink>
    <div class="wrapper">
      <form-default
        :contentTitle="$t('views.ForgotPass.contentTitle')"
        :titleLogin="$t('views.ForgotPass.titleLogin')"
        :inputs="inputs"
        :button="button"
      ></form-default>
      <alert-error
        :textError="messageErrorForgot"
        :nameButton="buttonText"
        action="errorForgot"
        v-if="errorForgotModal"
      ></alert-error>      
    </div>
  </div>
</template>
<script>
import FormDefault from "../../components/Forms/FormDefault";
import LogoHuddle from "../../components/customIcons/logoHuddle.vue";
import AlertError from "../../components/Alerts/AlertError";
import BackLink from "../../components/Buttons/BackLink.vue";
import Bus from "@/main.js";
import firebase from "firebase";
export default {
  data() {
    return {
      messageErrorForgot: "",
      buttonText: "",
      errorForgotModal: false,
      userEmail: "",
      userId: "",
      linkUrlDev: '.user-auth-dev.huddlebrasil.com',
      linkUrlDemo: '.user-auth-demo.huddlebrasil.com',
      linkUrlProd: '.user-auth.huddlebrasil.com',
      linkUrlLocal: 'localhost:8080',
      inputs: [
        {
          placeholder: "e-mail",
          type: "e-mail",
          name: "email"
        }
      ],
      button: {
        name: this.$t("views.ForgotPass.buttonName"),
        typeLogin: "email",
        action: "forgot-pass"
      },
      colors: {},
      game: ''
    };
  },
  components: {
    FormDefault,
    AlertError,
    BackLink,
    LogoHuddle
  },
  created() {
    Bus.$on("SetEnv", (data) => {
      this.env = data;
    });
    Bus.$on("forgot-pass", this.forgotPass);
    Bus.$on("errorForgot", this.errorForgot);
    this.colors = JSON.parse(localStorage.getItem("colors"));
		this.game = localStorage.getItem("game-redirect");
  },
  destroyed() {
    Bus.$off("forgot-pass", this.forgotPass);
    Bus.$off("errorForgot", this.errorForgot);
  },
  methods: {
    errorForgot() {
      email.focus();
      this.errorForgotModal = false;
    },
    replace(text, substitutes) {
      let textRes = text
      for (const field in substitutes) {
        textRes = textRes.replaceAll(`[${field}]`, substitutes[field])
      }
      return textRes
    },
    async constructEmail(emailBody) {
      let htmlEmail = emailBody
      htmlEmail = await this.replace(htmlEmail, {
        "title": this.$t("views.ResetPasswordEmail.title"),
        "img": this.$t("views.ResetPasswordEmail.image"),
        "txt0": this.$t("views.ResetPasswordEmail.bodyText[0]", {userName: localStorage.getItem('userName').split(" ")[0]}),
        "txt1": this.$t("views.ResetPasswordEmail.bodyText[1]"),
        "txt2": this.$t("views.ResetPasswordEmail.bodyText[2]"),
        "txt3": this.$t("views.ResetPasswordEmail.bodyText[3]"),
        "txt4": this.$t("views.ResetPasswordEmail.bodyText[4]"),
        "txt5": this.$t("views.ResetPasswordEmail.bodyText[5]")
      })
      return htmlEmail
    },
    async forgotPass() {
      // var auth = firebase.auth();
      // var emailAddress = email.value;
      const self = this;
      this.userEmail = email.value
      // console.log(process.env)
      if (process.env.VUE_APP_PROJECT_ID == 'authentication-service-01') await localStorage.setItem('linkUrl', `https://${this.game}${this.linkUrlProd}`)
      if (process.env.VUE_APP_PROJECT_ID == 'auth-serv-demo') await localStorage.setItem('linkUrl', `https://${this.game}${this.linkUrlDemo}`)
      if (process.env.VUE_APP_PROJECT_ID == 'auth-serv-dev') await localStorage.setItem('linkUrl', `https://${this.game}${this.linkUrlDev}`)
      if (process.env.VUE_APP_PROJECT_ID == 'auth-serv-dev' && this.game == this.linkUrlLocal) await localStorage.setItem('linkUrl', `http://${this.game}`)
      try{
        const userReq = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS}/users/?email=${email.value}`)
        this.userId = userReq.body.fields.id
        localStorage.setItem('userId', userReq.body.fields.id) 
        localStorage.setItem('userName', userReq.body.fields.name)
        localStorage.setItem('userCPF', userReq.body.fields.cpf)
        localStorage.setItem('userEmail', userReq.body.fields.email)
      }catch(error) {
        self.messageErrorForgot = self.$t(
          "views.ForgotPass.messages[1].messageErrorForgot"
        );
        self.buttonText = self.$t("views.ForgotPass.messages[1].buttonText");
        self.errorForgotModal = true;
        return
      }
      if (email.value == "") {
        self.messageErrorForgot = self.$t(
          "views.ForgotPass.messages[0].messageErrorForgot"
        );
        self.buttonText = self.$t("views.ForgotPass.messages[0].buttonText");
        self.errorForgotModal = true;
        return
        }
      let { resetPasswordEmail } = require('../../data/resetPasswordEmail')
      // const emailBody = this.constructEmail(resetPasswordEmail.body)
      try {
        const resSendEmail = await this.$http.post(
            `${process.env.VUE_APP_MAILER}/emails`,
            {
                "to": email.value, 
                "subject": this.$t("views.ResetPasswordEmail.title"),
                "email": await this.constructEmail(resetPasswordEmail.body),
                "type": "resetPassword",
                "origin": "Authentication Service"
            },
            {
              headers: {'Authorization': `${process.env.VUE_APP_AUTH_KEY}`}
            }
          )
        self.$router.replace("/send-forgot-success");
        
      } catch (error) {
        // console.log(resSendEmail)
        self.messageErrorForgot = self.$t(
            "views.ForgotPass.messages[3].messageErrorForgot"
          );
          self.buttonText = self.$t("views.ForgotPass.messages[3].buttonText");
          self.errorForgotModal = true;
        }
      // auth
      //   .sendPasswordResetEmail(email.value)
      //   .then(function(response) {
      //     self.$router.replace("/send-forgot-success");
      //   })
      //   .catch(function(error) {
      //     if (error.code == "auth/invalid-email") {
      //       self.messageErrorForgot = self.$t(
      //         "views.ForgotPass.messages[1].messageErrorForgot"
      //       );
      //       self.buttonText = self.$t(
      //         "views.ForgotPass.messages[1].buttonText"
      //       );
      //     } else if (error.code == "auth/user-not-found") {
      //       self.messageErrorForgot = self.$t(
      //         "views.ForgotPass.messages[2].messageErrorForgot"
      //       );
      //       self.buttonText = self.$t(
      //         "views.ForgotPass.messages[2].buttonText"
      //       );
      //     }
      //     self.errorForgotModal = true;
      //     console.log(error);
      //   });
      
    }
  },
	computed:{
		removeBgbyWindowSize(){
			const nobg = {
				'background': `linear-gradient(180deg, ${this.colors[this.colors.theme].from} 0%,  ${this.colors[this.colors.theme].to} 100%)`
			}
			const bg = {
				'background': `url(/img/background-${this.colors.theme}.png), linear-gradient(180deg, ${this.colors[this.colors.theme].from} 0%,  ${this.colors[this.colors.theme].to} 100%)`
			}
			return window.outerWidth >= 720 ? nobg : bg
		}	
	}  
};
</script>
<style lang="scss" scoped>
.forgot-pass {
  // min-height: calc(100vh - 110px);
  height: 100vh;
  display: flex;
  flex-direction: column;
}
  .wrapper{
		height: calc(94vh - 64px);

	}
  .bar{
		height: 2vh;
	}
</style>
